import react from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf'
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function ModalHistoriaGeneral(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [enfermedadActual, setEnfermedadActual] = useState('');
    const [revisionSistemas, setRevisionSistemas] = useState('');
    const [antecedentes, setAntecedentes] = useState('');
    const [antecedentesFamiliares, setAntecedentesFamiliares] = useState('');
    const [examenFisico, setExamenFisico] = useState('');
    const [examenesComplementarios, setExamenesComplementarios] = useState('');
    const [diagnostico, setDiagnostico] = useState('');
    const [planTratamiento, setPlanTratamiento] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();
    let userdata = [];

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id
            }
        }
        
        const config2 = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                },
                params: {
                    uid: userdata.user_id,
                    id: paciente_id
                }
            }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/perfil', config)
            .then(response => {
                if (response.status===200) {
                    
                    setNombreProfesional(response.data.name+' '+response.data.lastname);
                    //setEmailProfesional(response.data.email);
                    //setEspecialidad(response.data.especialidad);
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma);
                }
            })
            .catch(error => {
                console.log(error);
            });

    },[]);


    const motivoConsultaHandler = (event, editor) => {
        setMotivoConsulta(editor.getData());
    }
    const enfermedadHandler = (event, editor) => {
        setEnfermedadActual(editor.getData());
    }
    const revisionSistemasHandler = (event, editor) => {
        setRevisionSistemas(editor.getData());
    }
    const antecedentesHandler = (event, editor) => {
        setAntecedentes(editor.getData());
    }
    const antecedentesFamiliaresHandler = (event, editor) => {
        setAntecedentesFamiliares(editor.getData());
    }
    const examenFisicoHandler = (event, editor) => {
        setExamenFisico(editor.getData());
    }
    const examenesComplementariosHandler = (event, editor) => {
        setExamenesComplementarios(editor.getData());
    }
    const diagnosticoHandler = (event, editor) => {
        setDiagnostico(editor.getData());
    }
    const planTratamientoHandler = (event, editor) => {
        setPlanTratamiento(editor.getData());
    }
    



    const handleSubmit = (e) => {
        
        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            paciente_id: pacienteId,
            client_id: client.client_id,
            profesional: nombreProfesional,
            motivo_consulta: motivoConsulta, 
            enfermedad_actual: enfermedadActual,
            revision_sistemas: revisionSistemas,
            antecedentes: antecedentes,
            antecedentes_familiares: antecedentesFamiliares,
            examen_fisico: examenFisico,
            examenes_complementarios: examenesComplementarios,
            diagnostico: diagnostico,
            plan_tratamiento: planTratamiento,
            codigo_habilitacion: codigoHabilitacion,
            registro_medico: registroMedico
        }

        
        axios.post('/historia-general',config)
            .then(response => {
                setLoading(false);
                document.getElementById('myModal').click();
                props.actualizarHistorias();
                resetearForm();
            })
            .catch(error => {
                console.log(error.response.data);
                setErrorlist(error.response.data.errors);
            })  
    }


    const resetearForm = () => {

        setMotivoConsulta('');
        setEnfermedadActual('');
        setRevisionSistemas('');
        setAntecedentes('');
        setAntecedentesFamiliares('');
        setExamenFisico('');
        setExamenesComplementarios('');
        setDiagnostico('');
        setPlanTratamiento('');
    }


    if (loggedIn) {
        return (
                
                <div className="modal fade in" id="myModal">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Historia Clínica</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        <div className="modal-body" style={{paddingTop: '0.5rem'}}>
                
                            <section className="content">
                                <div className="container-fluid">

                                    <form id="role-form" onSubmit={handleSubmit} autoComplete="off">
                                        <div className="row">
                                            <div className="col-md-12">

                                                <div id="historiageneral">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#motivo-consulta" href="#">
                                                                        Motivo de Consulta
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="motivo-consulta" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={motivoConsultaHandler} data={motivoConsulta} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#enfermedad" href="#">
                                                                        Enfermedad Actual
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="enfermedad" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={enfermedadHandler} data={enfermedadActual} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#revision" href="#">
                                                                        Revisión por Sistemas
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="revision" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={revisionSistemasHandler} data={revisionSistemas} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#antecedentes-personales" href="#">
                                                                        Antecedentes Personales
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="antecedentes-personales" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={antecedentesHandler} data={antecedentes} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#antecedentes-familiares" href="#">
                                                                        Antecedentes Familiares
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="antecedentes-familiares" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={antecedentesFamiliaresHandler} data={antecedentesFamiliares} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#examen" href="#">
                                                                        Examen Físico
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="examen" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={examenFisicoHandler} data={examenFisico} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#complementarios" href="#">
                                                                        Examenes Complementarios
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="complementarios" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={examenesComplementariosHandler} data={examenesComplementarios} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#diagnostico" href="#">
                                                                        Diagnóstico
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="diagnostico" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={diagnosticoHandler} data={diagnostico} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="card">
                                                                <div className="card-header">
                                                                    <h4 className="card-title w-100">
                                                                        <a className="d-block w-100" data-toggle="collapse" data-target="#plan" href="#">
                                                                        Plan de Tratamiento
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="plan" className="collapse">
                                                                    <div className="form-group">
                                                                        <CKEditor editor={ClassicEditor} onChange={planTratamientoHandler} data={planTratamiento} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card">
                                                    <div id="profesional-atiende">
                                                        <div className="card-body" style={{padding: '0.7rem'}}>
                                                            <div className="row">
                                                                <div className="col-md-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                                        <br></br>
                                                                        {nombreProfesional}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="nombreProfesional">Registro médico</label>
                                                                        <br></br>
                                                                        {registroMedico}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                                        <br></br>
                                                                        {codigoHabilitacion}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-3">
                                                                    <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                                        <label htmlFor="nombreProfesional">Firma</label>
                                                                        <br></br>
                                                                        <img src={firmaimg} className="firma-profesional-hc" />
                                                                    </div>
                                                                </div>  
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                    
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <button type="submit" className="btn btn-primary">
                                                            Guardar&nbsp;
                                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                            
                                                        </button>
                                                    </div>
                                                </div>

                                                    
                                                
                                            
                    
                                            </div>
                                        </div>
                                    </form>
                                    
                                </div>
                            </section>
                

                        </div>

                    </div>
                </div>

            </div>
                            
        );
    }

    return (
        <Loading />
    );
}
export default ModalHistoriaGeneral;